import { PailRemoveOutlineIcon } from './PailRemoveOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 48413062-A335-454F-9349-04CD2B7BC628
 * name pail-remove-outline
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pail-remove-outline.svg
 * tags
 */
export const BucketRemoveOutlineIcon = PailRemoveOutlineIcon;
export default BucketRemoveOutlineIcon